import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexWrap: 'nowrap',
  },
  input: {
    '& > .MuiOutlinedInput-root': {
      height: '2.7rem',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: theme.palette.white.efesBackgroundLight,
      fontSize: '0.9rem',
      marginRight: -1,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  button: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: '0.5em',
    borderBottomRightRadius: '0.5em',
    height: '2.7rem',
    marginLeft: -1,
    backgroundColor: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontSize: '0.8rem',
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
}));

export default useStyles;
